import Api from "../apiService";

class WaybillsApi {
  index(companyId, params = {}) {
    return Api.getRequest(
      `companies/${companyId}/waybills`,
      params,
      Api.authHeaders()
    );
  }

  show(companyId, id) {
    return Api.getRequest(
      `companies/${companyId}/waybills/${id}`,
      {},
      Api.authHeaders()
    );
  }

  create(companyId, data) {
    return Api.postRequest(
      `companies/${companyId}/waybills`,
      data,
      Api.authHeaders()
    );
  }

  update(companyId, id, data) {
    return Api.patchRequest(
      `companies/${companyId}/waybills/${id}`,
      data,
      Api.authHeaders()
    );
  }

  destroy(companyId, id) {
    return Api.deleteRequest(
      `companies/${companyId}/waybills/${id}`,
      Api.authHeaders()
    );
  }
}

export default new WaybillsApi();
